module.exports = __webpack_public_path__ + "static/img/head_4.894cff16.png";